/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener('DOMContentLoaded', () => {
  try {
    const pathname = window.location.pathname;

    

    const params = new URLSearchParams(window.location.search);
    if (params.get('open-cart-drawer') === '1') {
      window.history.replaceState({}, '', window.location.pathname);

      const tryOpenDrawer = () => {
        const cartButton = document.querySelector('a.navlink--cart[data-cart-toggle]');
        if (cartButton) {
          cartButton.click();
          console.log('Clicked on cart button to open drawer');
        } else {
          console.warn('Cart button not found');
        }
      };

      tryOpenDrawer();
      setTimeout(tryOpenDrawer, 150);
      setTimeout(tryOpenDrawer, 300);
      setTimeout(tryOpenDrawer, 500);
      setTimeout(tryOpenDrawer, 1000);
    }
  } catch (e) {
    console.warn('custom.js: open cart drawer failed', e);
  }
});





  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
